module.exports = __webpack_public_path__ + "assets/add.3ffc1038.svg";